module.exports = __webpack_public_path__ + "static/scale-model-of-blackberry-farm-in-aurora-illinois-85524bdcb456b23dd5a727c60b81ef26.png";